/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assign_RefereeInputs */

const th_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มอบหมายผู้ตัดสิน…`)
};

const en_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign referee…`)
};

const ja_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`審判を割り当てる…`)
};

const zh_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指派裁判…`)
};

const es_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asignar árbitro…`)
};

const pt_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escalar árbitro…`)
};

const id_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugaskan wasit…`)
};

const fr_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désigner un arbitre…`)
};

const tl_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magtalaga ng referee…`)
};

const vi_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân công trọng tài…`)
};

const ko_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`심판 배정…`)
};

const de_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schiedsrichter ansetzen…`)
};

const ru_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назначить судью…`)
};

const tr_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakem ata…`)
};

const it_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assegna arbitro…`)
};

const pl_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyznacz sędziego…`)
};

const uk_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Призначити суддю…`)
};

const hi_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रेफ़री नियुक्त करें…`)
};

const ar_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعيين حكم…`)
};

const ms_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugaskan pengadil…`)
};

const bn_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রেফারি নিয়োগ…`)
};

const zh_tw2_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指派裁判…`)
};

const zh_hk2_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指派裁判…`)
};

const ur_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ریفری مقرر کریں…`)
};

const fa_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعیین داور…`)
};

const sw_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panga refa…`)
};

const nl_assign_referee = /** @type {(inputs: Assign_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheidsrechter aanwijzen…`)
};

/**
* | output |
* | --- |
* | "Assign referee…" |
*
* @param {Assign_RefereeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const assign_referee = /** @type {((inputs?: Assign_RefereeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assign_RefereeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_assign_referee(inputs)
	if (locale === "ja") return ja_assign_referee(inputs)
	if (locale === "zh") return zh_assign_referee(inputs)
	if (locale === "es") return es_assign_referee(inputs)
	if (locale === "pt") return pt_assign_referee(inputs)
	if (locale === "id") return id_assign_referee(inputs)
	if (locale === "fr") return fr_assign_referee(inputs)
	if (locale === "tl") return tl_assign_referee(inputs)
	if (locale === "vi") return vi_assign_referee(inputs)
	if (locale === "ko") return ko_assign_referee(inputs)
	if (locale === "de") return de_assign_referee(inputs)
	if (locale === "ru") return ru_assign_referee(inputs)
	if (locale === "tr") return tr_assign_referee(inputs)
	if (locale === "it") return it_assign_referee(inputs)
	if (locale === "pl") return pl_assign_referee(inputs)
	if (locale === "uk") return uk_assign_referee(inputs)
	if (locale === "hi") return hi_assign_referee(inputs)
	if (locale === "ar") return ar_assign_referee(inputs)
	if (locale === "ms") return ms_assign_referee(inputs)
	if (locale === "bn") return bn_assign_referee(inputs)
	if (locale === "zh-TW") return zh_tw2_assign_referee(inputs)
	if (locale === "zh-HK") return zh_hk2_assign_referee(inputs)
	if (locale === "ur") return ur_assign_referee(inputs)
	if (locale === "fa") return fa_assign_referee(inputs)
	if (locale === "sw") return sw_assign_referee(inputs)
	if (locale === "nl") return nl_assign_referee(inputs)
	return en_assign_referee(inputs)
});